import React, { useEffect, useState } from "react";
import { ReactComponent as Compose } from "../assets/svgs/compose.svg";
import { DeleteFilled } from "@ant-design/icons";
import Button from "../components/atoms/Button";
import CreateDialogBox from "../components/molecules/OffsetDetailsComponent/CreateDialogBox";
import CreateRegistry from "../components/molecules/OffsetDetailsComponent/CreateRegistry";
import { PlusOutlined } from "@ant-design/icons";
import { getBankDetails, getAllRegistries } from "../utils/api/offset-details";
import { Skeleton } from "antd";
import { useAuthContext } from "../context/AuthContext";
import TaxationAndCharges from "../components/organisms/TaxationAndCharges";
import ChargesHeader from "../components/organisms/TaxationAndCharges/ChargesHeader";
import { getTaxationCharges } from "../utils/api/taxation";
import UserCharges from "../components/organisms/TaxationAndCharges/UserCharges";
import { Checkbox } from "antd";
import toast from "react-hot-toast";
import updateSelectedRegistries from "../utils/api/updateSelectedRegistries";
import LinkExpiryTime from "../components/organisms/LinksExpiryTime";
import getRegitryandExpiryTime from "../utils/api/getRegistryandExpiryTime";
import { setPrimaryAccount } from "../utils/api/setPrimaryAccount";
import EditRegistry from "../components/molecules/OffsetDetailsComponent/EditRegistry";
import DeleteRegistryConfirmation from "../components/molecules/OffsetDetailsComponent/DeleteRegistryConfirmation";

const OffsetDetails = () => {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [createRegistryOpen, setCreateRegistryOpen] = useState(false);
  const [bankData, setBankData] = useState([]);
  const [registryData, setRegistryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedBankDetail, setSelectedBankDetail] = useState(null);
  const [selectedRegistryDetail, setSelectedRegistryDetail] = useState(null);
  const { setAuthUser } = useAuthContext();
  const [taxationData, setTaxationData] = useState([]);
  const [remittance, setRemittance] = useState([]);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [registry, setRegistry] = useState(null);
  const [deleteRegistryConformation, setDeleteRegistryConformation] =
    useState(false);
  const [paymentLinkTime, setPaymentLinkTime] = useState({
    unit: "",
    value: 0,
  });
  const [uploadDocumentTime, setUploadDocumentTime] = useState({
    unit: "",
    value: 0,
  });
  const [choosenRegistries, setChoosenRegistries] = useState([]);

  useEffect(() => {
    fetchOffsetData();
    getTaxationData();
    fetchBankDetails();
    fetchRegistries();
  }, [setAuthUser]);

  useEffect(() => {
    if (choosenRegistries.length > 0) {
      fetchRegistries();
    }
  }, [choosenRegistries]);

  const getTaxationData = async () => {
    let data = await getTaxationCharges();
    let tempRemittance = [];

    data.map((charge) => {
      if (charge.user_origin === "INT") {
        tempRemittance[0] = charge;
      } else {
        tempRemittance[1] = charge;
      }
    });

    setTaxationData(data);
    setRemittance(tempRemittance);
  };

  const fetchBankDetails = async () => {
    try {
      setLoading(true);
      const response = await getBankDetails(setAuthUser);
      if (response.success && response.data) {
        setBankData(response.data);
      } else {
        setError(error);
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchRegistries = async () => {
    try {
      setLoading(true);
      const response = await getAllRegistries(setAuthUser);
      if (response) {
        const updatedRegistryData = response.map((registry) => {
          const isChosen = choosenRegistries.some(
            (chosenRegistry) => chosenRegistry.ID === registry._id
          );
          return { ...registry, isSelected: isChosen };
        });
        setRegistryData(updatedRegistryData);
      } else {
        setError(error);
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchOffsetData = async () => {
    try {
      const response = await getRegitryandExpiryTime(setAuthUser);
      if (response.success) {
        const {
          payment_link_expiry_time,
          seller_upload_doc_expiry_time,
          registries,
        } = response.data;
        setPaymentLinkTime(payment_link_expiry_time);
        setUploadDocumentTime(seller_upload_doc_expiry_time);
        setChoosenRegistries(registries);
      }
    } catch (error) {
      toast.error(
        error.message || "An error occurred while fetching offset data"
      );
    }
  };

  if (loading) {
    return (
      <div className="flex flex-col gap-y-4 p-4">
        <Skeleton.Button block={true} active={true} />
        <Skeleton.Button block={true} active={true} />
        <Skeleton.Button block={true} active={true} />
        <Skeleton.Button block={true} active={true} />
      </div>
    );
  }

  if (error) {
    throw error;
  }

  // const handleSaveChanges = async () => {
  //   try {
  //     setLoading(true);
  //     const selectedRegistries = registryData.filter(
  //       (registry) => registry.isSelected
  //     );
  //     const formData = {
  //       registries: selectedRegistries.map((registry) => ({
  //         registryName: registry.registryName,
  //         image: registry.image,
  //         shortName: registry.shortName,
  //         ID: registry._id,
  //       })),
  //     };
  //     const response = await updateSelectedRegistries(formData, setAuthUser);
  //     if (response.success) {
  //       toast.success("Changes saved successfully!");
  //     } else {
  //       setError("Error saving changes");
  //     }
  //   } catch (error) {
  //     setError(error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handlePaymentLinkExpirySave = async (unit, value) => {
    try {
      const formData = {
        payment_link_expiry_time: {
          unit: unit,
          value: value,
        },
      };
      const response = await updateSelectedRegistries(formData, setAuthUser);
      if (response.success) {
        toast.success("Changes saved successfully!");
      } else {
        setError("Error saving changes");
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const handleDocumentLinkExpirySave = async (unit, value) => {
    try {
      const formData = {
        seller_upload_doc_expiry_time: {
          unit: unit,
          value: value,
        },
      };
      const response = await updateSelectedRegistries(formData, setAuthUser);
      if (response.success) {
        toast.success("Changes saved successfully!");
      } else {
        setError("Error saving changes");
      }
    } catch (error) {
      setError(error.message);
    }
  };

  // const handleCheckboxChange = (e, registryDetail) => {
  //   const isChecked = e.target.checked;
  //   // Update the selected registry's isSelected state
  //   setRegistryData((prevRegistryData) =>
  //     prevRegistryData.map((item) =>
  //       item._id === registryDetail._id
  //         ? { ...item, isSelected: isChecked }
  //         : item
  //     )
  //   );
  // };
  const handleSetPrimaryAccount = async (accountId) => {
    try {
      const response = await setPrimaryAccount(accountId, setAuthUser);
      if (response.success) {
        toast.success("Primary account updated successfully!");
        fetchBankDetails(); // Refresh bank details after updating the primary account
      } else {
        toast.error("Failed to update primary account");
      }
    } catch (error) {
      toast.error(
        error.message || "An error occurred while updating the primary account"
      );
    }
  };

  const handleOpenEdit = (e, registryDetail) => {
    setOpenEditPopup(true);
    setRegistry(registryDetail);
  };

  const handleDeleteRegistry = (e, registryDetail) => {
    setDeleteRegistryConformation(true);
    setRegistry(registryDetail);
  };

  return (
    <div className="h-full w-full p-6">
      <div className="pt-8 gap-y-4 overflow-y-auto h-full bg-white rounded-3xl shadow-formShadow no-scrollbar">
        <div>
          <div className="flex justify-between px-10 py-1 font-bold">
            <div className="text-2xl">Bank Details</div>
            <div className="ml-[74px]">
              <Button
                color={"blue_600"}
                varient={"primary"}
                onClick={() => {
                  setSelectedBankDetail(null);
                  setCreateDialogOpen(true);
                }}
                className={
                  "text-blue-800 px-3 border border-blue-800 text-[15px] py-1 font-medium flex items-center"
                }
              >
                <PlusOutlined className="mr-2" /> Create
              </Button>
            </div>
          </div>

          <div className="grid grid-cols-2">
            {bankData.map((bankDetail, index) => (
              <div key={bankDetail._id || index}>
                <div className="flex items-center">
                  <h1 className="text-2xl font-medium pl-10 mr-5">
                    Bank Details {index + 1}
                  </h1>
                  <Compose
                    className="cursor-pointer"
                    onClick={() => {
                      setSelectedBankDetail(bankDetail);
                      setCreateDialogOpen(true);
                    }}
                  />
                  <Checkbox
                    className="ml-10"
                    checked={bankDetail.isPrimary}
                    disabled={bankDetail.isPrimary}
                    onChange={() => handleSetPrimaryAccount(bankDetail._id)}
                  >
                    <p className=" text-base font-normal">Make it Primary</p>
                  </Checkbox>
                </div>
                <div className="mt-5">
                  <div className="">
                    <div className="flex pl-10 py-1 bg-blue-100">
                      <span className="w-1/3 text-[14px] font-bold">
                        Account Name -
                      </span>
                      <span className="w-2/3 text-[14px]">
                        {bankDetail.account_owner_name}
                      </span>
                    </div>
                    <div className="flex pl-10 py-1">
                      <span className="w-1/3 text-[14px] font-bold">
                        Account Number -
                      </span>
                      <span className="w-2/3 text-[14px]">
                        {bankDetail.account_no}
                      </span>
                    </div>
                    <div className="flex pl-10 py-1 bg-blue-100">
                      <span className="w-1/3 text-[14px] font-bold">
                        Bank Name -
                      </span>
                      <span className="w-2/3 text-[14px]">
                        {bankDetail.bank_name}
                      </span>
                    </div>
                    <div className="flex pl-10 py-1">
                      <span className="w-1/3 text-[14px] font-bold">
                        Bank Location -
                      </span>
                      <span className="w-2/3 text-[14px]">
                        {bankDetail.bank_address}
                      </span>
                    </div>
                    <div className="flex pl-10 py-1 bg-blue-100">
                      <span className="w-1/3 text-[14px] font-bold">
                        Account Type -
                      </span>
                      <span className="w-2/3 text-[14px]">
                        {bankDetail.account_type}
                      </span>
                    </div>
                    <div className="flex pl-10 py-1">
                      <span className="w-1/3 text-[14px] font-bold">
                        IFSC Code -
                      </span>
                      <span className="w-2/3 text-[14px]">
                        {bankDetail.IFSC_code}
                      </span>
                    </div>
                    <div className="flex pl-10 py-1 bg-blue-100">
                      <span className="w-1/3 text-[14px] font-bold">
                        Swift Code -
                      </span>
                      <span className="w-2/3 text-[14px]">
                        {bankDetail.swift_code}
                      </span>
                    </div>
                    <div className="flex pl-10 pt-1 pb-3">
                      <span className="w-1/3 text-[14px] font-bold">
                        MICR Code -
                      </span>
                      <span className="w-2/3 text-[14px]">
                        {bankDetail.MICR_code}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* </div> */}
          <div>
            <div className="flex justify-between px-10 py-1 font-bold">
              <div className="text-2xl">Registry Details</div>
              <div className="ml-[74px]">
                <Button
                  color={"blue_600"}
                  varient={"primary"}
                  onClick={() => {
                    setSelectedRegistryDetail(null);
                    setCreateRegistryOpen(true);
                  }}
                  className={
                    "text-blue-800 px-3 border border-blue-800 text-[15px] py-1 font-medium flex items-center"
                  }
                >
                  <PlusOutlined className="mr-2" /> Create
                </Button>
              </div>
            </div>

            <div className="grid grid-cols-2 mx-10 mt-4">
              {choosenRegistries.map((registryDetail, index) => (
                <div key={registryDetail._id || index}>
                  <div className="mt-5 mb-5">
                    <div className="">
                      {/* <div className="flex pl-10 py-1 bg-blue-100">
                        <span className="w-1/3 text-2xl font-bold">
                          {registryDetail.shortName}
                        </span>
                        <div>
                          <Checkbox
                            onChange={(e) =>
                              handleCheckboxChange(e, registryDetail)
                            }
                            checked={registryDetail.isSelected}
                            className="w-5 h-5"
                          />
                        </div>
                        <p className="px-2 text-md">Make it Primary</p>
                      </div> */}
                      <div className="flex pl-10 py-1 bg-blue-100">
                        <span className="w-1/3 text-2xl font-bold">
                          {registryDetail.shortName}
                        </span>
                        <div className="flex gap-3">
                          <Compose
                            className="cursor-pointer w-5 h-5 my-2"
                            onClick={(e) => handleOpenEdit(e, registryDetail)}
                          />
                          <DeleteFilled
                            className="cursor-pointer w-5 h-5 my-2"
                            onClick={(e) =>
                              handleDeleteRegistry(e, registryDetail)
                            }
                          />
                        </div>
                      </div>
                      <div className="flex pl-10 py-1 bg-blue-100">
                        <span className="w-1/3 text-[14px] font-normal">
                          Registry Name -
                        </span>
                        <span className="w-2/3 text-[14px] font-bold">
                          {registryDetail.registryName}
                        </span>
                      </div>
                      <div className="flex pl-10 py-1">
                        <span className="w-1/3 text-[14px]">ID -</span>
                        <span className="w-2/3 text-[14px] font-bold">
                          {registryDetail.registryID}
                        </span>
                      </div>
                      <div className="flex pl-10 py-1 bg-blue-100">
                        <span className="w-1/3 text-[14px]">User Name -</span>
                        <span className="w-2/3 text-[14px] font-bold">
                          {registryDetail.registryUserName}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="mx-10 mt-6">
              {/* <Button
                varient={"primary"}
                color={"blue"}
                className={"text-white px-6 py-2 "}
                onClick={handleSaveChanges}
              >
                Save Changes
              </Button> */}
            </div>
            {/* <div className="text-2xl font-semibold mx-10 mt-10">
              Previously Choosen Registries
            </div>
            <div className=" mx-10 mt-2">
              {choosenRegistries.length > 0 ? (
                choosenRegistries.map((registryDetail, index) => (
                  <div key={registryDetail.ID || index} className="py-2">
                    <p className="text-sm font-medium">
                      {registryDetail.registryName}
                    </p>
                  </div>
                ))
              ) : (
                <p>No registries selected.</p>
              )}
            </div> */}
          </div>
        </div>
        <div className="w-full mt-10">
          <h1 className="text-2xl w-full bg-blue-100 font-medium pl-10 py-4 mr-5">
            Taxation and charges
          </h1>
          <ChargesHeader Title={"Tax"}>
            {taxationData.map((item, index) => (
              <TaxationAndCharges
                key={index}
                data={item}
                type={"tax"}
                title="Tax"
                no={index}
              />
            ))}
          </ChargesHeader>

          <ChargesHeader Title={"Remittance"}>
            {remittance.map((item, index) => (
              <UserCharges
                key={index}
                name={"User"}
                unit={item.remittance.unit}
                user_origin={item.user_origin}
                value={item.remittance.value}
                type={"remittance"}
                title="Remittance"
                no={index}
              />
            ))}
          </ChargesHeader>

          <ChargesHeader Title={"Platform Fee"}>
            {taxationData.map((item, index) => (
              <TaxationAndCharges
                key={index}
                data={item}
                type={"platform_fee"}
                title="Platform Fee"
                no={index}
              />
            ))}
          </ChargesHeader>
          <ChargesHeader Title={"Payment Link expiry time"}>
            <LinkExpiryTime
              name={"All Users"}
              unit={paymentLinkTime.unit}
              value={paymentLinkTime.value}
              type={"remittance"}
              no={0}
              onSave={handlePaymentLinkExpirySave}
            />
          </ChargesHeader>
          <ChargesHeader Title={"Seller Upload Document expiry time"}>
            <LinkExpiryTime
              name={"Seller"}
              unit={uploadDocumentTime.unit}
              // unit={""}
              value={uploadDocumentTime.value}
              // value={0}
              type={"remittance"}
              no={0}
              onSave={handleDocumentLinkExpirySave}
            />
          </ChargesHeader>
        </div>
      </div>

      <CreateDialogBox
        open={createDialogOpen}
        bankData={selectedBankDetail}
        onOk={() => {
          fetchBankDetails();
          setCreateDialogOpen(false);
        }}
        onCancel={() => {
          setCreateDialogOpen(false);
        }}
      />
      <CreateRegistry
        open={createRegistryOpen}
        registries={registryData}
        registryData={selectedRegistryDetail}
        onOk={() => {
          fetchOffsetData();
          fetchRegistries();
          setCreateRegistryOpen(false);
        }}
        onCancel={() => {
          setCreateRegistryOpen(false);
        }}
      />
      {openEditPopup && (
        <EditRegistry
          open={openEditPopup}
          onOk={() => {
            fetchOffsetData();
            fetchRegistries();
            setOpenEditPopup(false);
          }}
          onCancel={() => {
            setOpenEditPopup(false);
          }}
          reg={registry}
        />
      )}
      {deleteRegistryConformation && (
        <DeleteRegistryConfirmation
          open={deleteRegistryConformation}
          registryDetail={registry}
          onOk={() => {
            fetchOffsetData();
            fetchRegistries();
            setDeleteRegistryConformation(false);
          }}
          onCancel={() => {
            setDeleteRegistryConformation(false);
          }}
        />
      )}
    </div>
  );
};

export default OffsetDetails;
